module.exports = __webpack_public_path__ + "assets/outlook.542cd14b.svg";